export var Name = 'remove-basket-item';
export var RemoveBasketItemEvent = Name;